// extracted by mini-css-extract-plugin
module.exports = {"slackSharedAuthIcons":"logged-out-screen_slackSharedAuthIcons_1X8"};